import { DISABLED } from '@angular/forms/src/model';
import { Component, OnInit } from '@angular/core';
import { Register } from '../../shared/user.model';
import { NgForm, Validators } from '@angular/forms';
import { UserService } from '../../shared/user.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';
import { RegistrationService } from '../../registration.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  Districts: any;
  States: any;
  register: Register;
  formSubmitted: boolean;
  data: any;
  districtlist: any;
  title = "Sainik Registration";
  textBoxDisabled = true;
  passwordpattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*?&]).{8,}$";

  constructor(private userService: RegistrationService, private errorHandler: ErrorHandler, private router: Router) {
    this.formSubmitted = false;
    this.register = new Register();
  }

  ngOnInit() {
    this.GetStates();
  }
  GetStates() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getStates();
    this.data.subscribe(
      (response) => {
        this.States = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetDistricts(stateId) {    
    if (stateId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getDistricts(stateId);
      this.data.subscribe(
        (response) => {
          this.districtlist = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.districtlist = undefined;
    }
  }


  GetAllDistrict() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getDistrictName();
    this.data.subscribe(
      (response:any) => {
        this.districtlist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
     
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      console.log(form.value);
      //form.value.State=this.register.State;      
      this.data = this.userService.registerCustomer(form.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";          
          if (form.value.PhoneNumber=='' || form.value.PhoneNumber==null)
          {
            swal('', 'Registered Successfully! Please login to your mail and Confirm your account', 'success');
          }
          else
          {
            swal('', 'Registered Successfully! An OTP is sent to your mobile number.', 'success');
          }
          this.router.navigate(['/login']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          // this.errorHandler.HandlerError(error);
          swal('',error.error.Message);
        });
    } else
      this.formSubmitted = true;
  }
  handleChange(form,event) 
  {
    var target = event.target;    
    if (target.value == 'Email')
    {
      form.controls["Email"].setValidators([Validators.required]);
      form.controls["Email"].updateValueAndValidity();
      form.controls["PhoneNumber"].clearValidators();
      form.controls["PhoneNumber"].updateValueAndValidity();
    }
    else if (target.value == 'PhoneNumber')
    {
      form.controls["PhoneNumber"].setValidators([Validators.required]);
      form.controls["PhoneNumber"].updateValueAndValidity();
      form.controls["Email"].clearValidators();
      form.controls["Email"].updateValueAndValidity();
      /*form.controls["Email"].clearValidators;    
      form.controls["Email"].updateValueAndValidity();
      form.controls["PhoneNumber"].setValidators();
      form.controls["PhoneNumber"].updateValueAndValidity();*/
    }
  } 
}


// WEBPACK FOOTER //
// ./src/app/registration/signup/signup.component.ts